module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAM0lEQVQ4T2NkoBJgpJI5DKMGEQ7J0TAaiDA6c+bMf8L24lYBjzWqGUSJa0B6R9MR4RAEAHzgBtkxEoD8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mini.png
// module id = 8w5N
// module chunks = 136